const form = $('.js-footer-subscribe-form');
const action = form.attr('action');
const success = $('.js-footer-subscribe-success');
success.hide();
form.on('submit', (e) => submitForm(e));

function submitForm(e){
	e.preventDefault();

	const query = $(form).serializeArray();
	const input = form.find('input[type="email"]');
	const inputParent = input.parent();

	query.push({
		name: 'sessid',
		value: $('meta[name="csrf-token"]').attr('content') || '',
	});

	if (form.valid()) {
		$.ajax({
			url: action,
			data: query,
			method: 'POST',
		}).then((data) => {
			// const errors = {};

			if (data.status === 'success') {
				form.hide();
				success.show();
			} else {
				// $.map(data.errors, (val) => {
				// 	errors[val.customData.field] = val.message
				// });
				// this.validator.showErrors(errors)
				const errors = data.errors.map(item => item.message).join(', ');
				inputParent.removeClass('is-success').addClass('is-error');
				inputParent.find('.form-error-text').remove();
				inputParent.append(`<div class="form-error-text">${errors}</div>`);
			}
		})
	}
}

